import { HTMLAttributes } from 'react'
import { cn } from '@/common/utilities.ts'

export type LabelProps = {
  text: string
  required?: boolean
  htmlFor?: string
} & HTMLAttributes<HTMLLabelElement>
export const Label = ({
  text,
  htmlFor,
  required = false,
  ...props
}: LabelProps) => {
  return (
    <label
      className={cn('block text-sm font-medium leading-6 text-gray-900')}
      htmlFor={htmlFor}
      {...props}
    >
      {text} {required === true && <span className="text-red-600">*</span>}
    </label>
  )
}
